const height = window.innerHeight;

export const isOnScreen = (headerHeight: number) => (rectTop: number, rectBottom: number) => {
  const baseHeight = height * 0.9;
  if (headerHeight <= rectTop && rectTop < baseHeight) return true;
  if (headerHeight <= rectBottom && rectBottom <= baseHeight) return true;
  return rectTop <= headerHeight && baseHeight <= rectBottom;
};

export const isOnScreenAxisX = (left: number, right: number) => (rectLeft: number, rectRight: number) => {
  if (left <= rectLeft && rectLeft <= right) return true;
  if (left <= rectRight && rectRight <= right) return true;
  return rectLeft <= left && right <= rectRight;
};

export const isPassingHeaderBottom = (headerHeight: number) => (rectTop: number, rectBottom: number) => {
  return rectTop < headerHeight && headerHeight < rectBottom;
};

export const showArea = (headerHeight: number) => (refCurrent: HTMLElement, setIsShown: (_: boolean) => void) => {
  if (refCurrent) {
    const rect = refCurrent.getBoundingClientRect();
    if (isOnScreen(headerHeight)(rect.top, rect.bottom)) {
      setIsShown(true);
    } else {
      setIsShown(false);
    }
  }
};

export const getPriceText = (price: number) => Math.floor(price).toLocaleString();

export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
export const numberWithCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const fillZeroTo2Digit = (n: number) => n.toString().padStart(2, "0");

export const getOnlyNumberText = (s: string) => s.replace(/[^0-9]/g, "");
export const getOnlyKoreanEnglishAndNumber = (s: string) => s.replace(/[^0-9a-zA-Zㄱ-ㅎ가-힣]/g, "");
